import { useEffect } from "react";
import hljs from "highlight.js";
import DOMPurify from "dompurify";
import "./modal.css";

function Cross({ onClick }) {
  return (
    <button onClick={onClick} className="modal-close" aria-label="close">
      X
    </button>
  );
}

export function Modal({ title, content, closeModal }) {
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        closeModal();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [closeModal]);

  useEffect(() => {
    hljs.highlightAll();
  }, []);

  return (
    <>
      <div className="modal-background" onClick={closeModal} />
      <div autoFocus className="modal">
        <Cross onClick={closeModal} />
        <div className="modal-content">
          <h1>{formatTitle(title)}</h1>
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
          />
        </div>
      </div>
    </>
  );
}

const PreFormattedTitles = {
  "world-of-software-design": "The World of Software Design",
  DDD: "A summary of DDD",
  MVC: "MVC (and its limits)",
};

function formatTitle(title) {
  if (PreFormattedTitles[title]) return PreFormattedTitles[title];

  const titleWithCapitalFirstLetter =
    title.charAt(0).toUpperCase() + title.slice(1);
  return titleWithCapitalFirstLetter.replaceAll("-", " ");
}
